import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { LaunchNavigator } from "@ionic-native/launch-navigator";
import { ContentBlock } from "../../models/content-block";
import { Api } from "../../providers/api";
import { CallNumber } from "@ionic-native/call-number";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { DesktopService } from "../../providers/desktop-service";
import { GoogleMapsService } from "../../providers/google-maps";

@Component({
    selector: '[content-block]',
    templateUrl: 'content-block.html',
})
export class ContentBlockComponent {

    private _content: string;

    @Input('content-block') public block: ContentBlock;
    @ViewChild('contentWrapper') public contentWrapperRef: ElementRef;

    public contentWrapper: HTMLDivElement;

    public get content(): string {
        return this._content;
    }

    public set content(content: string) {
        this._content = content as string;
        this.contentWrapper.innerHTML = this.content;
        this.bindTags();
    }

    constructor(
        private api: Api,
        private callNumber: CallNumber,
        private inAppBrowser: InAppBrowser,
        private launchNavigator: LaunchNavigator,
        private desktopService: DesktopService,
        private googleMaps: GoogleMapsService,
    ) {

    }

    public bindTags() {
        this.bindTagsByName('addr', addr => this.onClickAddr(addr));
        this.bindTagsByName('email', email => this.onClickEmail(email));
        this.bindTagsByName('fax', fax => this.onClickFax(fax));
        this.bindTagsByName('tel', tel => this.onClickTel(tel));
        this.bindTagsByName('web', web => this.onClickWeb(web));
    }

    public bindTagsByName(name: string, handler: (tag: HTMLElement) => void) {
        let wrapper = this.contentWrapper;

        let tags = wrapper.getElementsByTagName(name);
        for (let i = 0; i < tags.length; i++) {
            let tag = tags.item(i);
            tag.addEventListener('click', () => handler(tag as HTMLElement));
        }
    }

    public getCorrectedImagePaths(html: string): string {
        let wrapper = document.createElement('div');
        wrapper.innerHTML = html;

        let imgs = wrapper.getElementsByTagName('img');

        let endpoint = this.api.getEndpoint().origin;

        for (let i = 0; i < imgs.length; i++) {
            let img = imgs.item(i);
            let src = new URL(img.src);
            if (img.baseURI == document.baseURI) img.src = endpoint + src.pathname;
        }

        return wrapper.innerHTML;
    }

    public ngAfterViewInit() {
        this.contentWrapper = this.contentWrapperRef.nativeElement;

        let html = this.block.content;
        html = this.getCorrectedImagePaths(html);
        this.content = html;
    }

    public onClickAddr(addr: HTMLElement) {
        let dest = addr.innerText;

        if (this.desktopService.isDesktop()) {
            const directionsUrl =  this.googleMaps.getUrlDirections(dest);

            if (directionsUrl) {
                let href = document.createElement('a');
                href.setAttribute('href', directionsUrl);
                href.setAttribute('target', '_blank');
                href.click();
            }
        } else {
            this.launchNavigator.navigate(dest);
        }
    }

    public onClickEmail(email: HTMLElement) {
        let mailto = document.createElement('a');
        mailto.href = 'mailto:' + email.innerText;
        mailto.click();
    }

    public onClickFax(fax: HTMLElement) {
        if (this.desktopService.isDesktop()) {
            let faxTo = document.createElement('a');
            faxTo.href = 'fax:' + fax.innerText;
            faxTo.click();
        } else {
            this.callNumber.callNumber(fax.innerText, false);
        }
    }

    public onClickTel(tel: HTMLElement) {
        if (this.desktopService.isDesktop()) {
            let telTo = document.createElement('a');
            telTo.href = 'tel:' + tel.innerText;
            telTo.click();
        } else {
            this.callNumber.callNumber(tel.innerText, false);
        }
    }

    public onClickWeb(web: HTMLElement) {
        let url: URL;

        try {
            url = new URL(web.innerText);
        } catch (error) {
            url = new URL('http://' + web.innerText);
        }

        if (this.desktopService.isDesktop()) {
            let href = document.createElement('a');
            href.setAttribute('href', url.toString());
            href.setAttribute('target', '_blank');
            href.click();
        } else {
            this.inAppBrowser.create(url.href, '_system');
        }
    }

}



// WEBPACK FOOTER //
// ./src/components/content-block/content-block.ts